import store from '@/store';
import { orderAutorefreshIntervalNumber } from '@/config';

export class ActionScheduler
{
  interval: number;
  store: any;
  actionIdentifier: string;
  nextPossibleTime: string;
  active: Boolean;
  watchdog: any;

  constructor(
    store: any,
    actionIdentifier: string,
    nextPossibleTime: string,
    interval: number = 45000,
    autostart: Boolean = true
  ) {
    this.store = store;
    this.interval = interval;
    this.active = autostart;
    this.nextPossibleTime = nextPossibleTime;
    this.actionIdentifier = actionIdentifier;
    this.watchdog = setInterval(() => {
      this.tick();
    }, this.interval);
  }

  private tick() {
    if (
      this.isPossible() 
      && this.active 
      && this.isAllowedInThisMoment()
    ) {
      this.store.dispatch(this.actionIdentifier);
    } else {
      console.log('attempt');
    }
  }

  private isAllowedInThisMoment() {
    return this.store.getters[this.nextPossibleTime] < (new Date()).getTime();
  }

  private isPossible() {
    return this.store.getters['isOnline'] && this.store.getters['security/isLogged'];
  }

  start() {
    this.active = true;
  }

  stop() {
    this.active = false;
  }

  destroy() {
    this.stop();
    clearInterval(this.watchdog);
  }
}

export const ordersAutoUpdater: ActionScheduler = new ActionScheduler(
  store,
  'order/updateOrders',
  'order/nextPossibleUpdateTime',
  orderAutorefreshIntervalNumber,
  false
);